/** * Created by vouill on 11/13/17. */

<template>
  <div>
  <navbar></navbar>
  <section>

         <b-field grouped group-multiline>
             <div class="control">
                 <b-switch v-model="showDetailIcon">Show detail icon</b-switch>
             </div>
         </b-field>

         <b-table
             :data="orderHistory"
             ref="table"
             paginated
             per-page="5"
             :opened-detailed="defaultOpenedDetails"
             detailed
             detail-key="id"
             @details-open="(row, index) => $buefy.toast.open(`Expanded ${row.orderid}`)"
             :show-detail-icon="showDetailIcon"
             aria-next-label="Next page"
             aria-previous-label="Previous page"
             aria-page-label="Page"
             aria-current-label="Current page">

             <template slot-scope="props">
                 <b-table-column field="id" label="Order ID" width="80" numeric>
                     {{ props.row.orderid }}
                 </b-table-column>

                 <b-table-column field="orderdate" label="Order Date" sortable>
                 <span class="tag is-success">
                     {{ props.row.orderdatetime }}
                 </span>

                 </b-table-column>

                 <b-table-column field="reports" label="Reports" sortable>
                     {{ reportsInOrder(props.row.reports) }}
                 </b-table-column>

                 <b-table-column field="date" label="Total Price" sortable centered>
                     <span class="tag is-success">
                     {{ props.row.totalprice }}
                     </span>
                 </b-table-column>


             </template>

             <template slot="detail" slot-scope="props">
             <tr v-for="report in props.row.reports" :key="report.orderid">
                            <td v-if="showDetailIcon"></td>
                            <td  >Industry: {{ report.description }}</td>
                            <td  class="has-text-centered">, Region:{{ report.region }}</td>
                            <td v-if="report.salestype == 'Exact'" class="has-text-centered">, Sales Size: {{ report.salesexact }}</td>
                            <td v-else class="has-text-centered">, Sales Size: {{ report.salesrange }}</td>
                            <td  v-if="false" class="has-text-centered">, Price: {{ report.price }}</td>
                            <td  class="has-text-centered">
                            <b-button type="is-primary" @click="viewReport(report)">View Report</b-button>

                            </td>


                        </tr>
             </template>
         </b-table>

     </section>
     </div>
</template>

<style >
.headline {
  margin-top: 1em;
  display: flex;
  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
  }
}
</style>

<script>
import { mapGetters , mapState} from "vuex";
import Navbar from "./features/Navbar"
import axios from 'axios'
import { REPORT_PARAMETERS , REPORT_RESTAPI } from "../store/actions/report";

export default {
  name: "orders",
  components: {
  Navbar,
  },
  data() {
    return {
        orderHistory: [],
        defaultOpenedDetails: [1],
        showDetailIcon: true
    }
},
          computed: {
   ...mapGetters(["authCredentials","isAuthenticated", "authStatus", "isProfileLoaded","authLoading"]),
 ...mapState({
  authToken: state => state.auth.token ,
  authemail: state => state.auth.credentials.email ,
    profname: state => `${state.auth.authCredentials.token}`

})
},

mounted() {
  this.$store.commit(REPORT_RESTAPI, this.$api.REST_API)

	var URI = this.$api.REST_API + '/api/Order/History' 
                const options = {
      headers: {'X-Token': this.$store.getters.authToken}
    };
axios
  .post(URI, {userid: this.$store.getters.authCredentials.email },options)
  .then(r => {
  console.log(r)
  r.data.orders.forEach((order, index) => {
  this.orderHistory.push ( order )

  }
  );

  })
  .catch(e => {
  })


},
methods: {

viewReport(r) {
  console.log("Order.vue -- viewReport()")
  console.log(r)

//  var theParameters = {reportType: "NormRange", sales: 0,
//     naics: r.parameternaics, range: r.parametersizerange, state: "",
//     zip: "" };

  this.$store.commit(REPORT_PARAMETERS, r)
  this.$router.push({ name: "ViewReport" }).catch(err => {});
},
reportsInOrder (r) {
    return r.length
},
    toggle(row) {
        this.$refs.table.toggleDetails(row)
    }
},
  computed: {
    ...mapState({ profile: state => state.user.profile }),

    },

};
</script>



// WEBPACK FOOTER //
// src/components/Orders.vue